namespace Areas.Subscription {
    "use strict";


    const baseUrl = "/Subscription/Edit";
    export function updateRecord() {
        const form = $("#SubscriptionForm").dxForm("instance");
        const newData: any = form.option("formData");
        const keyId: any = form.option("KeyId");

        if (keyId == 0) {
            saveRecord(newData);
        } else {
            updateSubscriptionRecord(newData);
        }
    }

    export function saveRecord(newData: any) {
        const url = `${baseUrl}/Post`;
        const method = "POST"

        sendRequest(url, JSON.stringify(newData), method, (data) => { Areas.reloadPage(); });
    }

    function updateSubscriptionRecord(newData: any) {
        const url = `${baseUrl}/Put/${newData.SubscriptionId}`;
        const method = "PUT";

        sendRequest(url, JSON.stringify(newData), method, (data) => { Areas.reloadPage(); });
    }
}